import { render, staticRenderFns } from "./AccountList.vue?vue&type=template&id=2b2bb896&"
import script from "./AccountList.vue?vue&type=script&lang=js&"
export * from "./AccountList.vue?vue&type=script&lang=js&"
import style0 from "./AccountList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports